export type TTooltipTheme = 'light' | 'dark';

export type TTooltipTrigger = 'click' | 'hover' | 'hint' | 'focus' | 'noop';

export enum ETooltipPlacement {
  TOP_CENTER = 'top-center',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  LEFT = 'left',
  RIGHT = 'right',
  AUTO = 'auto',
}

export interface ITooltipOptions {
  content: string;
  theme?: TTooltipTheme;
  placement?: ETooltipPlacement,
  width?: string,
}
